var React = require('react');

function SvgLinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.524 1.366c0 .755-.626 1.367-1.4 1.367-.772 0-1.398-.612-1.398-1.367C.726.612 1.352 0 2.125 0s1.399.612 1.399 1.366zm.011 2.46H.715v8.744h2.82V3.826zm4.502 0H5.235v8.744h2.803V7.98c0-2.552 3.4-2.761 3.4 0v4.59h2.814V7.033c0-4.306-5.033-4.15-6.215-2.03V3.826z","fill":"#71706A"}));
}

SvgLinkedinInline.defaultProps = {"width":"15","height":"13","fill":"none"};

module.exports = SvgLinkedinInline;

SvgLinkedinInline.default = SvgLinkedinInline;
